import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import PollIcon from "@material-ui/icons/Poll";
import SettingsIcon from "@material-ui/icons/Settings";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { colorPicker } from "../common";
import { buttonStyles, cardStyles } from "../styles";
import { ProgressBar } from "./ProgressBar";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { isMobileOnly } from 'react-device-detect';

export const DeckCard = props => {
    // if (!props.index) {
    // }
    
    const cards = cardStyles();
    const buttons = buttonStyles();
    
    let _obj = {
        pathname: props.flashcard ? "/showFlashCard" : "/questionScreen",
    }

    if (props.flashcard) {
        _obj.deckid = props.deckID;
        _obj.year = 0;
    } else {
        _obj.deckID = props.deckID;
        _obj.gameMode = typeof props.gameMode !== 'undefined' ? props.gameMode : 3;
    }

    return (
        <Container
            disableGutters={props.disableGutters || false}
            fixed={props.fixed || false}
            maxWidth={props.maxWidth || "xs"}
            className={clsx(cards.deckContainer, colorPicker(props.deckColor))}
            style={{margin: "0 0 16px"}}
        >
            <Grid
                container={props.gridContainer || true}
                className={cards.gridContainer}
                alignContent={props.alignGrid || "stretch"}
                alignItems={props.alignGridItems || "stretch"}
                direction={props.gridDirection || "row"}
                item={props.gridItems || false}
                justify={props.justifyGrid || "flex-start"}
                lg={props.gridLG || false}
                md={props.gridMD || false}
                sm={props.gridSM || false}
                spacing={props.gridSpacing || 0}
                wrap={props.gridWrap || "wrap"}
                xl={props.gridXL || false}
                xs={props.gridXS || false}
                zeroMinWidth={props.gridZeroMinWidth || false}
            >
                <Grid item xs={12}>
                    <Typography
                        className={props.titleClass}
                        variant={props.headerSize || "h4"}
                        align={props.headerAlign || "left"}
                        display={props.display || "initial"}
                        gutterBottom={props.gutterBottom || true}
                        noWrap={props.noWrap || false}
                        paragraph={props.paragraph || true}
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {props.deckName || "Deck #1"}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography
                        className={colorPicker(props.textColor)}
                        variant={props.headerSize || "h6"}
                        align={props.headerAlign || "left"}
                        display={props.display || "initial"}
                        gutterBottom={props.gutterBottom || true}
                        noWrap={props.noWrap || false}
                        paragraph={props.paragraph || true}
                    >
                        Your progress {props.owner ? null : ( <span>(subscription)</span>)}
                    </Typography>
                    {props.isWrong 
                        ? (<ProgressBar value={0} />)
                        : (<ProgressBar value={props.complete ? props.complete : 0} />)
                    }
                </Grid>

                <div
                    style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "flex-start", flexDirection:"row", margin: "8px 0 0" }}
                >
                    <div style={{marginTop:"4px", display:"flex", flexDirection: "column", justifyContent: "flex-start", alignItems:  "flex-start", fontSize: "0.9em"}}>
                        <div className="margin-bottom-4">{Number(props.gameMode) != 4 ? "Open Book" : "Closed Book"}</div>
                    </div>

                    {props.isWrong || props.totalQuestions === 0
                        ? null
                        : (
                            <Link>
                                <IconButton 
                                    className={buttons.deckCardButtons} 
                                    aria-label="copy-deck"
                                    onClick={() => props.copyDeck()}
                                >
                                    <FileCopyIcon className={buttons.deckButtons} />
                                </IconButton>

                                <div className={buttons.deckCardButtonText}>
                                    Copy
                                </div>
                            </Link>
                        )
                    }
                    <>
                        {props.totalQuestions
                            ? (
                                <>
                                    <Link
                                        to={{
                                            pathname: "/editDeckScreen", 
                                            deckID: props.deckID,
                                            gameMode: (typeof props.gameMode !== 'undefined' ? props.gameMode : 3)
                                        }}
                                    >

                                        <IconButton className={buttons.deckCardButtons} aria-label="settings">
                                            <SettingsIcon className={buttons.deckButtons} />
                                        </IconButton>
                                        <div className={buttons.deckCardButtonText}>
                                            Settings
                                        </div> 
                                    </Link>
                                    
                                    <Link
                                        to={{
                                            pathname: "/testResultScreen",
                                            deckID: props.deckID,
                                            gameMode: (typeof props.gameMode !== 'undefined' ? props.gameMode : 3)
                                        }}
                                    >
                                        <IconButton className={buttons.deckCardButtons} aria-label="summary">
                                            <PollIcon className={buttons.deckButtons} />
                                        </IconButton>
                                        <div className={buttons.deckCardButtonText}>
                                            Summary
                                        </div>
                                    </Link>

                                    <Link
                                        to={_obj}
                                    >
                                        <IconButton className={buttons.deckCardButtons} aria-label="go-deck">
                                            <PlayCircleFilledIcon className={buttons.deckButtons} />
                                        </IconButton>
                                        <div className={buttons.deckCardButtonText}>
                                            Deck
                                        </div>
                                    </Link>
                                </>
                            ) : (
                                <Link
                                    to={{
                                        pathname: "/editDeckScreen",
                                        deckID: props.deckID,
                                        gameMode: (typeof props.gameMode !== 'undefined' ? props.gameMode : 3)
                                    }}
                                >

                                    <IconButton className={buttons.deckCardButtons} aria-label="settings">
                                        <SettingsIcon className={buttons.deckButtons} />
                                    </IconButton>
                                    <div className={buttons.deckCardButtonText}>
                                        Settings
                                    </div>
                                </Link>
                            )    
                        }
                    </>
                </div>
            </Grid>
        </Container>
    );
};
